<template>
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="1.5" y="1.5" width="23" height="23" rx="2.5" stroke="white" stroke-width="3" />
  </svg>
</template>
